import { render } from "./ListIngreso.vue?vue&type=template&id=1d1fec38"
import script from "./ListIngreso.vue?vue&type=script&lang=js"
export * from "./ListIngreso.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__